/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ModalFlight.vue?vue&type=template&id=d56794a2"
import script from "./ModalFlight.ts?vue&type=script&lang=ts&external"
export * from "./ModalFlight.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports